angular.module('mercury.modules.placeholders')
.controller('DefaultPlaceholderCtrl', ["$scope", "userinfo", function($scope, userinfo) {
  $scope.username = userinfo.userDetails().firstName;
}]);
